import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { CompanyStateLeadApiService } from '../../empresas/services/company-state-lead-api.service';
import { CompanyStateLeadResponse } from '../models/company-state-lead.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-company-state-lead-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './company-state-lead-list.component.html'
})
export class CompanyStateLeadListComponent implements OnInit {
  items: CompanyStateLeadResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: CompanyStateLeadApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll({ page: 0, size: 100 }).subscribe({
      next: (data) => {
        this.items = data.content;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los estados de empresa';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-empresas/estados/crear']);
  }

  editar(item: CompanyStateLeadResponse): void {
    this.router.navigate(['/config-empresas/estados/editar', item.id]);
  }

  async eliminar(item: CompanyStateLeadResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar estado',
      message: `¿Está seguro de eliminar el estado "${item.name}"?`
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Estado', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el estado' });
      }
    });
  }
}
